export default {
  Model: {},
  Actions: {
    GET_PARTNER_INFO_SUCCESS: 'PartnerInfo/GET_PARTNER_INFO_SUCCESS',
  },
  State: {
    PARTNER_INFO: 'PARTNER_INFO',
  },
};
